import translation from 'translation';

const dateFormatter = () => translation.dateFormatter;

export default {
    datepickerDateFormat () {
        return dateFormatter().datepickerDateFormat();
    },

    timepickerTimeFormat () {
        return dateFormatter().timepickerTimeFormat();
    },

    // moment formatters
    momentDateFormat () {
        return dateFormatter().momentDateFormat();
    },

    momentDateFormatShort () {
        return dateFormatter().momentDateFormatShort();
    },

    momentDatetimeFormat () {
        return dateFormatter().momentDatetimeFormat();
    },

    momentDateMonthFormat () {
        return dateFormatter().momentDateMonthFormat();
    },

    momentTimeFormat (options) {
        options = options || {};
        return dateFormatter().momentTimeFormat(options);
    },

    momentDateGroupedMonthsFormat () {
        return 'YYYY, MMMM';
    },

    momentDateGroupedQuartersFormat () {
        return dateFormatter().momentDateGroupedQuartersFormat();
    },

    momentDateGroupedYearsFormat () {
        return 'YYYY';
    },

    momentMonthApiFormat () {
        return 'YYYY-MM';
    },

    momentDateApiFormat () {
        return 'YYYY-MM-DD';
    },

    momentTimeApiFormat () {
        return 'HH:mm:ss';
    },

    momentDateTimeApiFormat () {
        return 'YYYY-MM-DDTHH:mm:ss';
    }
};
